import Immutable from "seamless-immutable";

import { GET_BADGES_RESPONSES, UPDATE_BADGE, CREATE_BADGE, CLEAR_BADGES, LOGOUT, IMPERSONATE_USER, STOP_IMPERSONATE_USER } from "../actions/Types";

// initial state

const initialState = Immutable({
  items: [],
});

// reducers

const setBadgesResponses = (state, action) => {
  const { data } = action;
  return Immutable.merge(state, { items: data });
};

const setEditBadge = (state, action) => {
  const { items } = action;
  return Immutable.merge(state, { items: items });
};

const setCreateBadge = (state, action) => {
  const { items } = action;
  return Immutable.merge(state, { items: items });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BADGES_RESPONSES:
      return setBadgesResponses(state, action);
    case UPDATE_BADGE:
      return setEditBadge(state, action);
    case CREATE_BADGE:
      return setCreateBadge(state, action);
    case IMPERSONATE_USER:
    case STOP_IMPERSONATE_USER:
    case CLEAR_BADGES:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
